import {Flex,Grid,GridItem,Box,Select,InputGroup,Button,
  InputLeftElement,Input,Heading,Text,TableContainer,
  Checkbox,Table,Thead,Tbody,Th,Textarea,Tr,Td,} from '@chakra-ui/react';
  import styled from "@emotion/styled";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState,useEffect } from 'react';
  import {useAtom,atom} from 'jotai'
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../../utils/apiCall';
  import {  openAtom, notificationAtom, openNAtom, modalAtom } from "../../../../context";
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';



const indexAtom = atom<number | null>(null);

  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
  `
export default function BatchInvite() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_n_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const queryClient = useQueryClient();
 const [Name,set_Name] = useState('');
 const [Venue,set_Venue] = useState('');
 const [InductionDate,set_Date] = useState('');
const [PaymentDeadlineDate,set_PaymentDeadlineDate] = useState('');


  const [,set_modal] = useAtom(modalAtom);
  const [is_check_all,set_is_check_all] = useState<any>(false);
  const [checked_ids,set_checked_ids] = useState<any>([]);

  const [selected_status,set_selected_status] = useState<null | string>(null);

 const { data: all_invite = [], isLoading } = useQuery(
  ["all-induction"],
  async ()  => {
    const pageSize = 100; // backend caps at 100
    let currentPage = 1;
    let allData: any[] = [];

    while (true) {
      const res = await apiCall().get(
        `/Exam/students/dueForInduction?PageNumber=${currentPage}&PageSize=${pageSize}`
      );

      const pageData = res.data?.reportItems || [];
      allData = [...allData, ...pageData];

      if (currentPage >= res.data.PageCount) break;
      currentPage++;
    }

    return allData;
  }
);

  const [search,set_search] = useState('');

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
  let new_data = filter_data?.filter((eData:any) =>
  Object.values(eData).join(" ").toLowerCase().includes(val.toLowerCase())
);
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_invite)
    }
    else set_filter_data(all_invite)
  }
  
const [filter_data, set_filter_data] = useState<any[]>([]);

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
const currentItems = Array.isArray(filter_data)
  ? filter_data.slice(itemOffset, endOffset)
  : [];  const pageCount = Array.isArray(filter_data)
  ? Math.ceil(filter_data.length / itemsPerPage)
  : 0;

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };


   const {isLoading:approveIsLoading,mutate:multi_invitation} = useMutation({
     mutationKey:['induction-invite'],
     mutationFn: async(payload:any)=> {
     // console.log(checked_ids,'checked')
      return await apiCall().post(`/Exam/BatchExamInductionInvite`,payload)
    },
     onSuccess(data:any){
       //console.log(data,'data')
       set_notification({
         type:'success',
         message:data.data.Message || ' Induction Invite Sent Successfully'
       });
       set_n_open(true);
       queryClient.invalidateQueries(['all-induction-invite'])
     },
     onError(error:any){
       set_notification({
         type:'error',
         message:error.data.Message || 'Error Occured'
       });
       set_n_open(true);
     },
     onSettled(){
       set_open(false);

     },
   })

   const handleMultipleInvites = () =>{
     if(Name && Venue && InductionDate && checked_ids && checked_ids.length > 0 ){
        multi_invitation({
          StudentNumbers:[
            ...checked_ids
          ],
          InductionName:Name,
          InductionDate,
          InductionVenue:Venue,
          PaymentDeadlineDate:PaymentDeadlineDate,

        });
     }
     else{
      set_notification({
        type:'error',
        message:'fill on all required field and select a Student'
      })
      set_n_open(true);
     }
   }
  


  const handleMultipleCheck=()=>{
    if(!is_check_all){
      let allStudents = filter_data && filter_data.length > 0 ? 
        filter_data.map((eStudent:any)=>eStudent.StudentNo):[];
      set_checked_ids(allStudents);
    }else{
      set_checked_ids([]);
    }
    set_is_check_all(!is_check_all);
  }

  const handleSingleCheck=(StudentNo:string) =>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    if(check){
      set_checked_ids((all_students:any) => all_students.filter((eStudent:string) => eStudent !== StudentNo))
    }else{
      set_checked_ids([...checked_ids,StudentNo])
    }

  }
  const handleCheck=(StudentNo:string)=>{
    let check = checked_ids.find((eStudent:string) => eStudent === StudentNo);
    return check?true:false;
  }

  useEffect(()=>{
    if(selected_status){
      let data = all_invite.filter((eData:any) => eData.Status.toLowerCase() === selected_status.toLowerCase());
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(all_invite);
    }
    set_checked_ids([]);
  },[selected_status])

 useEffect(() => {
  if (Array.isArray(all_invite)) {
    set_filter_data(all_invite);
  } else {
    set_filter_data([]); // fallback
  }
}, [all_invite]);


  return (
    <Grid minW="80dvw" p="20px" templateColumns="1fr">
      <GridItem as={Flex} gap="20px" align="center">
        <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
          <InputLeftElement pointerEvents='none'>
            <SearchIcon color='gray.300' />
          </InputLeftElement>
          <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
        </InputGroup>
        <Select w="120px" onChange={(e:any)=>set_selected_status(e.target.value)} placeholder='Status'>
          <option>Inducted</option>
          <option>Applied for induction</option>
          <option>Due for Induction</option>
          <option>Invited for induction</option>
        </Select>
      </GridItem>
      <GridItem as={Flex} flexDir="column" gap="20px">
        <Heading>Batch Invites</Heading>
        <Text>Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={{...HeadStyle,maxWidth:"50px"}}>
                  <label>
                    <Checkbox colorScheme={is_check_all?'green':'none'} isChecked={is_check_all} onChange={handleMultipleCheck} />
                  </label>
                </Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>IsInvited</Th>
                <Th sx={HeadStyle}>HasApplied</Th>
                <Th sx={HeadStyle}>IsOldStudent</Th>
                <Th sx={HeadStyle}>Ismoved</Th>
                {/* <Th sx={HeadStyle}>NewMembershipNo</Th> */}
                <Th sx={HeadStyle}>Status</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.StudentNo}>
                <Td sx={{...DataStyle,maxWidth:"50px"}}>
                  <label>
                  <Checkbox colorScheme={handleCheck(eCandidate.StudentNo)?'green':'none'} isChecked={handleCheck(eCandidate.StudentNo)} onChange={()=>handleSingleCheck(eCandidate.StudentNo)} />
                  </label>
                </Td>
                <Td sx={DataStyle}>{eCandidate.FirstName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.LastName || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.StudentNo || 'N/A'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsInvitedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.HasAppliedForInduction?'Yes':'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsOldStudent?'Yes': 'No'}</Td>
                <Td sx={DataStyle}>{eCandidate.IsMovedToMembership ?'Yes':'No'}</Td>
                {/* <Td sx={DataStyle}>{eCandidate.FinalMembershipNo?'Yes':'No'}</Td> */}
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
              
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Pending Approvals'  
      }
        <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>
      </GridItem>
      <GridItem as={Flex} flexDir="column" gap="20px" >
        <Flex w="100%" flexDir="column" gap="10px">
          <strong>Induction Name</strong> 
          <Input value={Name} onChange={(e)=>set_Name(e.target.value)} placeholder='Induction Name'borderColor="green"
            type="text" />
          <strong>Induction Venue</strong> 
          <Input value={Venue} onChange={(e)=>set_Venue(e.target.value)} placeholder='Induction Venue' borderColor="green" type="text" />
          <strong>Induction Date</strong> 
          <Input value={InductionDate} onChange={(e)=>set_Date(e.target.value)} borderColor="green" type="datetime-local" />
          <strong>Payment Deadline Date</strong>
          <Input value={PaymentDeadlineDate} onChange={(e)=>set_PaymentDeadlineDate(e.target.value)} placeholder='Induction Venue' borderColor="green"  type="datetime-local" />
        </Flex>
        <Flex justify="center" gap="30px" align="center">
          <Button  bg="var(--dark-green-color)" onClick={checked_ids && checked_ids.length > 0?()=> handleMultipleInvites ():()=>{}}
           color="var(--white-color)" width="130px"  >
            {approveIsLoading?'Loading':'Send Invites'}
          </Button>
        </Flex> 
      </GridItem>
    </Grid>
    
  )
    
  }
  const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`